let config = [
  {
    name: '助播素材',
    type: 'module-name'
  },
  {
    key: 'property_data',
    name: '属性',
    type: 'custom',
    content: [
      {
        key: 'list',
        name: '数据',
        type: 'upload-data',
        link_down: 'https://cdn.mockuai.com/tms/template-material-01.xlsx',
        format: (list)=>{
          const map = {
            '类型': 'type',
            '图片链接': 'img_url',
            '视频链接': 'video_url',
          };
          const data = list.map(item=>{
            const obj = {};
            Object.keys(item).forEach(key=>{
              const mapKey = map[key];
              obj[mapKey] = item[key];
            });
            return obj;
          });
          return data;
        }
      },
    ]
  }
];
export default config;
